import { get } from './core'

/**
 * Async get my experiences
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function my_experiences__get (token) {
  return get('/api/me/experiences', token)
}

/**
 * Async get my bookings
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function my_bookings__get (token) {
  return get('/api/me/bookings', token)
}


// WEBPACK FOOTER //
// ./src/api/experiences.js